import * as types from './actionTypes';

// ShiftLate
export const fetchShiftLate = (unit_id) => ({
  type: types.FETCH_TIME_DEDUCTION_SHIFT_LATE_REQUEST,
  payload: { unit_id },
});

export const saveShiftLate = (data) => ({
  type: types.SAVE_TIME_DEDUCTION_SHIFT_LATE_REQUEST,
  payload: data,
});

// ShiftLateCancel
export const fetchShiftLateCancel = (payload) => ({
  type: types.FETCH_TIME_DEDUCTION_SHIFT_LATE_CANCEL_REQUEST,
  payload,
});

export const saveShiftLateCancel = (data) => ({
  type: types.SAVE_TIME_DEDUCTION_SHIFT_LATE_CANCEL_REQUEST,
  payload: data,
});

// ViewPunchOrders
export const fetchViewPunchOrders = (unit_id) => ({
  type: types.FETCH_VIEW_PUNCH_ORDERS_REQUEST,
  payload: { unit_id },
});

export const fetchShiftLateApproval = (payload) => ({
  type: types.FETCH_SHIFT_LATE_APPROVAL_REQUEST,
  payload,
});

export const saveShiftLateApproval = (data) => ({
  type: types.SAVE_SHIFT_LATE_APPROVAL_REQUEST,
  payload: data,
});

export const fetchLateReport = (payload) => ({
  type: types.FETCH_LATE_REPORT_REQUEST,
  payload,
});

export const fetchLateConsolidatedReport = (payload) => ({
  type: types.FETCH_LATE_CONSOLIDATED_REPORT_REQUEST,
  payload,
});

export const fetchShiftLateApprovalEmployeeRequest = (payload) => ({
  type: types.FETCH_SHIFT_LATE_APPROVAL_EMPLOYEE_REQUEST,
  payload
});

export const fetchShiftLateApprovalEmployeeSuccess = (data) => ({
  type: types.FETCH_SHIFT_LATE_APPROVAL_EMPLOYEE_SUCCESS,
  payload: data,
});

export const fetchShiftLateApprovalEmployeeFailure = (error) => ({
  type: types.FETCH_SHIFT_LATE_APPROVAL_EMPLOYEE_FAILURE,
  payload: error,
});

export const fetchShiftLateCancelEmployeeRequest = (payload) => ({
  type: types.FETCH_SHIFT_LATE_CANCEL_EMPLOYEE_REQUEST,
  payload
});

export const fetchShiftLateCancelEmployeeSuccess = (data) => ({
  type: types.FETCH_SHIFT_LATE_CANCEL_EMPLOYEE_SUCCESS,
  payload: data
});

export const fetchShiftLateCancelEmployeeFailure = (error) => ({
  type: types.FETCH_SHIFT_LATE_CANCEL_EMPLOYEE_FAILURE,
  payload: error
});

export const resetShiftLateCancel = () => ({
  type: types.RESET_TIME_DEDUCTION_SHIFT_LATE_CANCEL
});